<template>
  <div class="sec-cart">
    <div class="cart-header d-flex justify-content-between column_sp">
      <div class="d-flex align-items-center">
        <h2 class="mb-0 mr-3">カート</h2>
        <!-- 「開く」をクリックでカートに追加した商品一覧が展開し、ボタンが閉じるに切り替わる -->
        <button class="open-img" v-show="!isOpen" v-on:click="toggle(true)">
          開く
        </button>
        <button class="close-img" v-show="isOpen" v-on:click="toggle(false)">
          閉じる
        </button>
      </div>
      <div class="d-md-flex align-items-center">
        <div class="text-center">使用可能ポイント {{point}}ポイント</div>
        <div class="btns mx-3">
          <button v-on:click="next">カートに進む</button>
        </div>
      </div>
    </div>
    <!-- 「開く」をクリックで展開 -->
    <div class="container" v-show="isOpen">
      <div class="d-flex py-3 border-bottom only_pc">
        <div class="shohin_group text-center"><p>商品</p></div>
        <div class="shohin_quantity text-center"><p>個数</p></div>
        <div class="shohin_price text-center"><p>価格</p></div>
      </div>
      <div id="CartList">
        <ul>
          <CartDetailItem
            v-for="(item, idx) in cartItems"
            :key="item.code"
            :no="idx + 1"
            :itemNo="item.no"
            :optionCount="item.optionCount"
            :itemCount="item.itemCount"
            :name="item.name"
            :type="item.type"
            :code="item.code"
            :price="item.price"
            @loadCart="loadCart"
          />
        </ul>
      </div>
      <!-- 動的HTML生成部 カート小計 -->
      <div id="CartSubtotal" class="d-flex my-3">
        <div class="shohin_price_all text-right"><p>小計</p></div>
        <div class="shohin_price text-right">
          <p>{{ subtotal }}円</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.sec-cart {
  position: sticky;
  bottom: 0;
  background-color: #fff;
  margin-top: 50px;
  padding-bottom: 15px;
  border-top: 3px solid #eee;
  max-height: 70vh;
}
.sec-cart .cart-header {
  padding: 20px 30px;
}
.sec-cart .container {
  padding-bottom: 0;
  margin-bottom: 0;
  height: 43vh;
  overflow: scroll;
}
ul.cart_list {
  border-top: 1px solid #eee;
}
ul.cart_list select {
  width: 75px;
}
ul.cart_list li {
  border-bottom: 1px solid #eee;
  padding: 17px 0;
}
ul.cart_list li button {
  padding: 5px 10px;
}

@media screen and (min-width: 1px) and (max-width: 699px) {
  .cart-header {
    padding: 0px !important;
    margin-top: 5px;
  }
  .cart-header div.btns {
    margin: 5px 0px 0px !important;
  }
}
</style>

<script>
import Request from "@/modules/Request";
import Store from "@/modules/Store";
import CartDetailItem from "./CartDetailItem";

let request = new Request();
let store = new Store();

export default {
  mounted() {
    // this.loadCart();
  },
  components: {
    CartDetailItem,
  },
  // computed: {
  //   cartItems() {
  //     return this.$store.state.cartItems;
  //   }
  // },
  data() {
    return {
      isOpen: false,
      cartItems: [],
      subtotal: 0,
      point:0,
      message: "",
      isProxy: false,
    };
  },
  methods: {
    toggle(open) {
      this.isOpen = open;
    },
    next() {
      let postParams = [];
      let requestParams = request.createParams(
        "webMdlCart",
        "canNextStep",
        postParams
      );
      request
        .create()
        .post("", requestParams)
        .then(() => {
          this.$router.push("/cart");
        });
    },
    loadCart() {
      if(store.get('isProxy') == '1'){
        this.isProxy = true;
      }else{
        this.isProxy = false;
      }
      console.log('isProxy:'+store.get('isProxy'))
      console.log('loadCart');
      let postParams = [];
      let requestParams = request.createParams(
        "webMdlCart",
        "getSubtotal",
        postParams
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          console.log(data.cartItems)
          this.cartItems = data.cartItems
          console.log('splicestart')
          this.cartItems.splice();
          console.log('spliceend')
          this.subtotal = data.CartSubtotal;
          this.message = data.message;
          this.limit = data.PossibleQuantity;
          this.point = data.PossessionPoint;
        });
    },
  },
};
</script>